import configApi from '../../api/config';
import { StorageManager } from '../../storage';

type TResponseCommonConfigData = {
  reaction?: string;
  commonSwitch?: string;
  deleteAccount?: string;
  newUserGuide?: string;
};

type TCallback = (data: ICommonConfigData) => void;

export type TReaction = {
  id: string;
  icon_url: string;
  type_id: string;
  disable_highlight: boolean;
  text: string;
};

export type TPanelReaction = {
  id: string;
};

type TChatReaction = {
  reactions: TReaction[];
  panel_reaction_id_list: TPanelReaction[];
};

export interface ICommonConfigData {
  reaction?: TChatReaction;
  commonSwitch?: Record<string, unknown>;
  deleteAccount?: Record<string, unknown>;
  newUserGuide?: Record<string, unknown>;
}

export class CommonConfigManager {
  private static instance: CommonConfigManager;

  public static getInstance(): CommonConfigManager {
    if (!CommonConfigManager.instance) {
      CommonConfigManager.instance = new CommonConfigManager();
    }
    return CommonConfigManager.instance;
  }

  private callbackList: TCallback[] = [];
  private configData: ICommonConfigData = {};

  init(): void {
    const { config } = this;
    if (config) {
      this.configData = config;
    }
    this.updateFormRemote();
  }

  get config(): ICommonConfigData {
    if (Object.keys(this.configData).length > 0) return this.configData;
    return StorageManager.getInstance().get<ICommonConfigData>('common_config') || this.configData;
  }

  update(): void {
    StorageManager.getInstance().set('common_config', this.configData);
    this.callbackList.forEach(callback => callback.call(callback, this.configData));
  }

  listener(callback: (configData?: ICommonConfigData) => void): void {
    if (typeof callback === 'function') {
      this.callbackList.push(callback);
    }
  }

  removeListener(callback: (configData?: ICommonConfigData) => void): void {
    if (typeof callback === 'function') {
      const index = this.callbackList.findIndex(item => item === callback);
      if (index >= 0) {
        this.callbackList.slice(index, 1);
      }
    }
  }

  private async updateFormRemote() {
    const configData = await configApi.getCommonConfig<TResponseCommonConfigData>();
    const { reaction, commonSwitch, deleteAccount, newUserGuide } = configData.data;
    const formatReaction: TChatReaction = reaction ? JSON.parse(reaction) : { reactions: [] };
    formatReaction.reactions = formatReaction?.reactions?.map(item => ({
      ...item,
      id: String(item.id),
    })) || [];
    this.configData = {
      reaction: formatReaction,
      commonSwitch: commonSwitch ? JSON.parse(commonSwitch) : {},
      deleteAccount: deleteAccount ? JSON.parse(deleteAccount) : {},
      newUserGuide: newUserGuide ? JSON.parse(newUserGuide) : {},
    };
    this.update();
  }
}

export default CommonConfigManager;
